import { useSelector, useDispatch } from 'react-redux';
import { setWalletSidebarOpen } from '../state/uiSlice';
import SharedRightSlideout from '../components/Layout/SharedRightSlideout';
import { productIntegrations } from '../config/productIntegrations';

export default function CryptoWalletSidebar() {
  const isWalletSidebarOpen = useSelector((state) => state.ui.isWalletSidebarOpen);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setWalletSidebarOpen({ isOpen: false, type: null }));
  };

  return (
    <SharedRightSlideout
      isOpen={isWalletSidebarOpen}
      onClose={handleClose}
      className="crypto-wallet-shared-slideout agentping-wallet-shared-slideout"
      bodyClassName="agentping-wallet-slideout-body"
    >
      <div className="agentping-wallet-panel">
        <a
          href={productIntegrations.agentWolfProfileUrl}
          className="agentping-wallet-security-link"
          target="_blank"
          rel="noreferrer"
        >
          Security: Agent Wolf
        </a>
        <div className="agentping-wallet-frame-shell">
          <iframe
            src={productIntegrations.agentPingWalletUrl}
            title="AgentPing Wallet"
            className="agentping-wallet-frame"
            allow="clipboard-read; clipboard-write; payment"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </div>
    </SharedRightSlideout>
  );
}


